module.exports = __webpack_public_path__ + "static/media/flat.622bdbbf.fbx";